import { createSelector } from 'reselect';

const selectGlobalProgram = (state: any) => state.globalProgram;


export const selectGlobalProgramCurrentItem = createSelector([selectGlobalProgram], (globalProgram) => globalProgram.current);

export const selectGlobalProgramListItems = createSelector([selectGlobalProgram], (globalProgram) => globalProgram.list);

export const selectGlobalProgramItemById = (itemId: any) =>
    createSelector(selectGlobalProgramListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalProgramCreatedItem = createSelector([selectGlobalProgram], (globalProgram) => globalProgram.create);

export const selectGlobalProgramUpdatedItem = createSelector([selectGlobalProgram], (globalProgram) => globalProgram.update);

export const selectGlobalProgramQueryItems = createSelector([selectGlobalProgram], (globalProgram) => globalProgram.query);

export const selectGlobalProgramReadItem = createSelector([selectGlobalProgram], (globalProgram) => globalProgram.read);

export const selectGlobalProgramDeletedItem = createSelector([selectGlobalProgram], (globalProgram) => globalProgram.delete);

export const selectGlobalProgramSearchedItems = createSelector([selectGlobalProgram], (globalProgram) => globalProgram.search);

export const selectGlobalProgramItemsCount = createSelector([selectGlobalProgram], (globalProgram) => globalProgram.count);

export const selectGlobalProgramItemsFilter = createSelector([selectGlobalProgram], (globalProgram) => globalProgram.filter);